module.exports = __webpack_public_path__ + "static/media/down.40c07224.svg";